import { Routes, Route } from "react-router-dom";
import ConnectingVisits from "./ConnectingVisits";
import ConnectingVisitCreateEdit from "./ConnectingVisitCreateEdit";
import ConnectingVisitPlanning from "./ConnectingVisitPlanning";

const index = () => {
	return (
		<Routes>
			<Route index element={<ConnectingVisits />} />
			<Route path='/create' element={<ConnectingVisitCreateEdit />} />
			<Route path='/:id/edit' element={<ConnectingVisitCreateEdit />} />
			<Route path='/planning' element={<ConnectingVisitPlanning />} />
		</Routes>
	);
};

export default index;
